<template>
  <div class="form-error-wrapper">
    <div class="status form-expire">
      <img src="@/assets/images/404.png">
      <p class="tip">页面不见了</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound'
};
</script>
<style lang="scss" scoped>
.form-error-wrapper {
  background: #f2f2f2;
  height: 100vh;
  text-align: center;
  .status {
    img {
      width: 98px;
      height: 116px;
      margin-top: 25%;
    }
    .tip {
      margin-top: 30px;
      font-size: 16px;
      line-height: 22px;
      color: #919299;
    }
  }
}
</style>
